interface Props {
  color?: string
  width?: number
  height?: number
}

export const ReelsIcon = ({ color = '#6F6F6F', width = 21, height = 17 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 0C20.3284 0 21 0.671577 21 1.5V15.5C21 16.3284 20.3284 17 19.5 17H1.5C0.671577 17 0 16.3284 0 15.5V1.5C0 0.671573 0.671573 0 1.5 0H19.5ZM1 15.5C1 15.7762 1.22385 16 1.5 16H4V12H1V15.5ZM5 16H16V1H5V16ZM17 16H19.5C19.7762 16 20 15.7762 20 15.5V12H17V16ZM8.75781 5.5625C8.91669 5.47455 9.11062 5.47999 9.26465 5.57617L13.2646 8.07617C13.4108 8.16754 13.5 8.3276 13.5 8.5C13.5 8.6724 13.4108 8.83246 13.2646 8.92383L9.26465 11.4238C9.11062 11.52 8.91669 11.5254 8.75781 11.4375C8.59884 11.3494 8.5 11.1818 8.5 11V6L8.50488 5.93262C8.52595 5.77762 8.61873 5.63959 8.75781 5.5625ZM1 11H4V6H1V11ZM17 11H20V6H17V11ZM9.5 10.0977L12.0566 8.5L9.5 6.90137V10.0977ZM1.5 1C1.22386 1 1 1.22386 1 1.5V5H4V1H1.5ZM17 5H20V1.5C20 1.22385 19.7762 1 19.5 1H17V5Z"
        fill={color}
      />
    </svg>
  )
}
